import { CommonInfoService } from './../../cart-process/common-info.service';
import { Component, Input } from '@angular/core';
import { DetailsModalService } from '../../services/details-modal.service';
import { OrderDetailsDataSlotComponent } from '../order-details/order-details-data-slot.component';
import { IExtendedAdditionalBundleSet } from '../../interfaces/additional-bundles.interface';

@Component({
  selector: '[new-offer-data-section]',
  templateUrl: './new-offer-data-section.component.html',
})
export class NewOfferDataSectionComponent extends OrderDetailsDataSlotComponent {

  public additionalBundle: IExtendedAdditionalBundleSet;
  public headerText: string;
  public isVirginBrand: boolean;

  constructor(
    private detailsModalService: DetailsModalService,
    private commonInfo: CommonInfoService
  ) {
    super();

    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  @Input()
  set bundle(bundle: IExtendedAdditionalBundleSet) {
    this.additionalBundle = bundle;
  }

  public internetDetailsModalShow(event: Event) {
    event.preventDefault();

    const el = event.target as HTMLElement;

    this.detailsModalService.showInternetDetails(el);
  }
}
